  import React, { useState,useRef,useEffect } from "react";
  import { useLocation,useNavigate } from "react-router-dom";
  import PreviewReceta from "../Configuracion/Modulosconfiguracion/PreviewReceta";
  import html2canvas from 'html2canvas';
  import { jsPDF } from 'jspdf';
  import { obtenerConfiguracionReceta, crearReceta, crearRecetaCrearYFirmarFirmada, auditarRecetaExportada } from "../../../services/recetas"; 
  import { getPacientes } from "../../../services/pacientes";
  import "./RecetaFormulario.css";
  import FirmaEfimeraModal from "../Recetas electronicas/FirmaEfimeraModal";
  import { getPerfilMedico } from "../../../services/usuarios";
  import { getHistoriaClinicaPorPaciente, getConsultasHistoriaClinica } from "../../../services/historiaClinica";
  import { initialConfig, camposConfigurables } from "./RecetaConfig";
  import RecetaFormularioForm from "./RecetaFormularioForm";
  import { obtenerEstadoSuscripcion } from "../../../services/pagos";
      
      const RecetaFormulario = ({ receta: propReceta, onVolver }) => {
        const location = useLocation();
        const receta = propReceta || location.state?.receta || null;
        const navigate = useNavigate();
        const [firmaOpen, setFirmaOpen] = useState(false);
        const [firmaCreds, setFirmaCreds] = useState(null); // {cer,key,password}
        const [digitalON, setDigitalON] = useState(false);
        const [firmaHabilitada, setFirmaHabilitada] = useState(false);
        const [exportandoPDF, setExportandoPDF] = useState(false);
        const [guardandoReceta, setGuardandoReceta] = useState(false);
        
        // 🔹 Si no hay receta, redirigir al Dashboard
        useEffect(() => {
          if (!receta && location.pathname !== "/dashboard/recetas/formulario") {
            
            navigate("/dashboard/recetas");
          }
        }, [receta, navigate, location.pathname]);
                
        const [modoPreview, setModoPreview] = useState(!!receta);
        const [config, setConfig] = useState({
          ...initialConfig,
          diagnostico: receta?.diagnostico || "",
          // tratamiento se conserva SOLO para render legacy (no se edita ni se envía)
          tratamiento: receta?.tratamiento || "",
          fecha: receta?.fecha || new Date().toLocaleDateString("fr-CA"),
        });      
        
        // 🔒 Cargar si el médico tiene habilitada la firma digital
        useEffect(() => {
          const cargarPerfil = async () => {
            try {
              const perfil = await getPerfilMedico();
              if (perfil?.habilitacion_receta_digital === true) {
                setFirmaHabilitada(true);
              } else {
                setFirmaHabilitada(false);
              }
            } catch (error) {
              console.error("Error al cargar perfil médico:", error);
              setFirmaHabilitada(false);
            }
          };
          cargarPerfil();
        }, []);
              
        const [paciente, setPaciente] = useState("");
        const [pacientes, setPacientes] = useState([]);
        const [pacienteId, setPacienteId] = useState("");
        const [consultaId, setConsultaId] = useState(null); 
        const [opcionesAsociacion, setOpcionesAsociacion] = useState([]);
        const recetaRef = useRef(null);
        
        // 🔹 Cargar Configuración del Doctor + Configuración Base + Pacientes
        useEffect(() => {
          const cargarDatos = async () => {
            try {
              const medicoId = "3127"; // ID del médico (puede ser dinámico)
              const configGuardada = await obtenerConfiguracionReceta(medicoId);
              
              setConfig((prevConfig) => ({
                ...initialConfig, // ✅ Se cargan valores base primero
                ...(configGuardada ? configGuardada.configuracion : {}), // ✅ Fusionamos configuración guardada si existe
                diagnostico: receta?.diagnostico || prevConfig.diagnostico || "",  // 🔥 Mantiene el diagnóstico si ya existía
                tratamiento: receta?.tratamiento || prevConfig.tratamiento || "",  // 🔥 Mantiene el tratamiento si ya existía
                fecha: receta?.fecha || prevConfig.fecha || new Date().toLocaleDateString("fr-CA"), // 🔥 Mantiene la fecha si ya existía
                paciente_id: receta?.paciente_id || prevConfig.paciente_id || "",
                nombrePaciente: receta?.nombrePaciente || prevConfig.nombrePaciente || "",
                edad_en_emision: receta?.edad_en_emision ?? prevConfig.edad_en_emision ?? null,
                fecha_nacimiento_en_emision: receta?.fecha_nacimiento_en_emision ?? prevConfig.fecha_nacimiento_en_emision ?? null,
                signos_vitales_snapshot: receta?.signos_vitales_snapshot ?? prevConfig.signos_vitales_snapshot ?? {},
              }));
        
              // 🔹 Cargar pacientes
              const listaPacientes = await getPacientes();
              // 🔒 Filtrar solo pacientes activos (no archivados)
              const soloActivos = listaPacientes.filter(p => p.activo === true);
              setPacientes(listaPacientes);
              setPacientes(soloActivos);
        
              // 🔹 Si la receta ya tiene un paciente asignado, preseleccionarlo
              if (receta?.paciente_id) {
                const pacienteEncontrado = listaPacientes.find(p => p.id === receta.paciente_id);
                if (pacienteEncontrado) {
                  setPaciente(`${pacienteEncontrado.nombre} ${pacienteEncontrado.apellido_paterno} ${pacienteEncontrado.apellido_materno}`);
                }
                setPacienteId(receta.paciente_id);
              }
            } catch (error) {
              console.error("Error cargando datos:", error);
              setConfig(initialConfig); // 🔥 En caso de error, aplicamos configuración base
            }
          };
        
          cargarDatos();
        
          const handleMessage = (event) => {
            if (event.data?.type === "refreshPacientes") {
              cargarDatos(); // 🔄 Recargar la lista de pacientes si llega un evento externo
            }
          };
        
          window.addEventListener("message", handleMessage);
        
          return () => {
            window.removeEventListener("message", handleMessage);
          };
        }, [receta]); // 🔥 Ahora escucha cambios en `receta` completa, evitando el warning 
        
        // 🔹 Cargar historia clínica y consultas del paciente seleccionado
        useEffect(() => {
            const cargarOrigenes = async () => {
                if (!pacienteId) {
                    setOpcionesAsociacion([]);
                    return;
                }

                try {
                  
                    const historia = await getHistoriaClinicaPorPaciente(pacienteId);
                    let opciones = [];

                    if (historia && historia.id) {
                        // 🔹 Normalizar historia clínica como consulta inicial
                      const historiaNormalizada = {
                          tipo: "historia",
                          id: historia.id,
                          fecha:
                              historia.fecha_consulta ||
                              historia.fecha_creacion ||
                              historia.creado_en,
                          diagnostico: historia.diagnosticos || "",
                          plan_tratamiento: historia.plan_tratamiento || "",
                          medicamentos: historia.medicamentos || [],              
                          signos: {
                            sistolica: historia.sistolica,
                            diastolica: historia.diastolica,
                            frecuencia_cardiaca: historia.frecuencia_cardiaca,
                            frecuencia_respiratoria: historia.frecuencia_respiratoria,
                            temperatura: historia.temperatura,
                            saturacion_oxigeno: historia.saturacion_oxigeno,
                            peso: historia.peso,
                            altura: historia.altura,
                            imc: historia.imc,
                            categoria_imc: historia.categoria_imc,
                         }
                      };

                        const consultas = await getConsultasHistoriaClinica(historia.id);
                        
                        const seguimientosNormalizados = Array.isArray(consultas)
                            ? consultas.map((c) => ({
                                tipo: "consulta",
                                id: c.id,
                                fecha:
                                    c.fecha_consulta ||
                                    c.fechaConsulta ||
                                    c.creado_en,
                                diagnostico: c.diagnosticos || "",
                                plan_tratamiento: c.plan_tratamiento || "",
                                medicamentos: c.medicamentos || [],
                                signos: {
                                    sistolica: c.sistolica,
                                    diastolica: c.diastolica,
                                    frecuencia_cardiaca: c.frecuencia_cardiaca,
                                    frecuencia_respiratoria: c.frecuencia_respiratoria,
                                    temperatura: c.temperatura,
                                    saturacion_oxigeno: c.saturacion_oxigeno,
                                    peso: c.peso,
                                    altura: c.altura,
                                    imc: c.imc,
                                    categoria_imc: c.categoria_imc,
                                 }
                              }))
                              : [];

                          // 🔥 UNIR Y ORDENAR DESCENDENTE (más reciente primero)
                          const timeline = [...seguimientosNormalizados, historiaNormalizada]
                              .sort((a, b) => new Date(b.fecha) - new Date(a.fecha));

                          // 🔢 Numerar como en ConsultasPaciente
                          timeline.forEach((item, index) => {
                              const numeroConsulta = timeline.length - index;
                              const fechaFormateada = item.fecha
                                  ? new Date(item.fecha).toLocaleDateString("es-MX")
                                  : "Sin fecha";

                                opciones.push({
                                  tipo: item.tipo,
                                  id: item.id,
                                  label: `Consulta ${numeroConsulta} — ${fechaFormateada} — ${item.diagnostico}`,
                                  diagnostico: item.diagnostico,
                                  plan_tratamiento: item.plan_tratamiento || "",
                                  medicamentos: item.medicamentos || [],
                                  signos: item.signos,
                                  edad_en_emision: null,
                                  fecha_nacimiento_en_emision: null,
                                });
                            });
                    }
                    setOpcionesAsociacion(opciones);
                } catch (error) {
                    console.error("Error cargando historia/consultas:", error);
                    setOpcionesAsociacion([]);
                }
            };

            cargarOrigenes();
        }, [pacienteId]);

      const handleExportPDF = async () => {
         if (exportandoPDF) return;
        setExportandoPDF(true);
           // 🔒 Validar suscripción antes de exportar
        try {
          const data = await obtenerEstadoSuscripcion();
          const status = data?.status;

          if (!["active", "trialing"].includes(status)) {
            alert("Tu suscripción no está activa. Por favor, actualiza tu plan para continuar.");
            setExportandoPDF(false);
            return; // 🚫 STOP
          }
        } catch (error) {
          alert("No se pudo validar tu suscripción. Contacta a soporte.");
          setExportandoPDF(false);
          return;
        }

        // Seleccionamos el div con clase 'preview-receta'
        const element = document.querySelector(".preview-receta");
      
        if (!element) {
          console.error("No se encontró el elemento con la clase 'preview-receta'.");
          setExportandoPDF(false);
          return;
        }
        // 🔥 Apaga el borde SOLO para exportar
        element.classList.add("no-border"); 
        // Deshabilitamos temporalmente el zoom para evitar distorsiones
        const originalTransform = element.style.transform;
        element.style.transform = "";
      
        // Capturamos el contenido del div con html2canvas
        const canvas = await html2canvas(element, {
          scale: 2, // Aumenta la calidad del renderizado
          useCORS: true, // Permite manejar imágenes externas
        });
      
        // Restauramos el zoom original después de la captura
        element.style.transform = originalTransform;
      
              // Convertimos el canvas en una imagen
      const imgData = canvas.toDataURL("image/png");

      const W = config.anchoPersonalizado;  // ancho real EN CM
      const H = config.altoPersonalizado;   // alto real EN CM

      // Si W > H → jsPDF NO permite portrait → hay que darle landscape
      const orientation = W > H ? "landscape" : "portrait";

      // AQUÍ estaba tu punto: format SIEMPRE es [ancho, alto]
      const pdf = new jsPDF({
        orientation: orientation,
        unit: "cm",
        format: [W, H],   // SIEMPRE en este orden
      });
      await auditarRecetaExportada(receta?.id || null);
      // La imagen debe entrar EXACTAMENTE con el mismo par W,H
      pdf.addImage(imgData, "PNG", 0, 0, W, H);
      
      // Descargamos el PDF
      pdf.save("receta-media-carta.pdf");
      //log exportacion
      
      // 🔥 En cuanto termina, recupera el borde
      element.classList.remove("no-border");
      setExportandoPDF(false);
    };

          // Genera el PDF desde el preview, pero regresa un Blob (para e.firma)
      const getPdfBlobFromPreview = async () => {
        const element = document.querySelector(".preview-receta");
        if (!element) throw new Error("No se encontró .preview-receta");

        //
        // 1️⃣ Quitar borde SOLO para exportar
        //
        element.classList.add("no-border");

        //
        // 2️⃣ Quitar temporalmente el zoom
        //
        const originalTransform = element.style.transform;
        element.style.transform = "";

        //
        // 3️⃣ Capturar preview a canvas (alta calidad)
        //
        const canvas = await html2canvas(element, { scale: 2, useCORS: true });

        //
        // 4️⃣ Restaurar el zoom original
        //
        element.style.transform = originalTransform;

        //
        // 5️⃣ Convertir canvas a imagen
        //
        const imgData = canvas.toDataURL("image/png");

        //
        // 6️⃣ FORZAR Carta (Letter): 21.59 cm × 27.94 cm
        //    Si quieres portrait estricto, usa orientation: "portrait"
        //    (es lo normal en receta digital)
        //
        const W = 21.59; // ancho en cm
        const H = 27.94; // alto en cm

        // Siempre portrait para receta digital formal
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "cm",
          format: [W, H],
        });

        //
        // 7️⃣ Insertar imagen EXACTA al tamaño real
        //
        pdf.addImage(imgData, "PNG", 0, 0, W, H);

        //
        // 8️⃣ Restaurar borde al preview (UI regresa normal)
        //
        element.classList.remove("no-border");

        //
        // 9️⃣ Devolver Blob para flujo ON/e.firma
        //
        return pdf.output("blob");
      };

      const handleAgregarPaciente = () => {
        navigate("/dashboard/alta-paciente", "_blank"); // 🔗 Abre la página de alta de pacientes en una nueva ventana
      };

      const _handleGuardarInterno = async () => {
        if (!pacienteId) {
          alert("⚠️ Debes seleccionar un paciente antes de guardar la receta.");
          return;
        }
      
        // 📌 Obtener la historia clínica del paciente (si está disponible)
        const historiaClinicaId = pacientes.find(p => p.id === pacienteId)?.historiaClinicaId;
        const medsLimpios = (Array.isArray(medicamentos) ? medicamentos : [])
          .filter(m => (m?.nombre || "").trim() || (m?.indicaciones || "").trim())
          .map(m => ({
            nombre: (m?.nombre || "").trim(),
            indicaciones: (m?.indicaciones || "").trim(),
          }));
          if (medsLimpios.length === 0) {
            alert("Agrega al menos un medicamento.");
            return;
          }
                // 🔍 Separar origen seleccionado (historia vs consulta)
          let consultaUUID = null;
          let historiaUUID = historiaClinicaId || null;

          if (consultaId) {
              // EXTRAER SOLO EL TIPO SIN CORTAR UUID
              const tipo = consultaId.startsWith("consulta-") ? "consulta"
                        : consultaId.startsWith("historia-") ? "historia"
                        : null;

              const uuid = consultaId.replace("consulta-", "").replace("historia-", "");
              if (tipo === "consulta") {
                  consultaUUID = uuid;
              } else if (tipo === "historia") {
                  historiaUUID = uuid;
              }
            // si es historia, ya está en historiaUUID (historiaClinicaId)
          }
        const nuevaReceta = {
          paciente_id: pacienteId,
          nombrePaciente: paciente,
          diagnostico: config.diagnostico,
          tratamiento: config.tratamiento, 
          medicamentos: medsLimpios,
          fecha: config.fecha || new Date().toISOString().split("T")[0],
          consulta: consultaUUID,           
          historia_clinica: historiaUUID,
          edad_en_emision: config.edad_en_emision || null,
          diagnostico_snapshot: config.diagnostico_snapshot || "",
          signos_vitales_snapshot: config.signos_vitales_snapshot || {},
          fecha_nacimiento_en_emision: config.fecha_nacimiento_en_emision || null,
        };
        

        // --- Flujo ON: si el switch está prendido y ya hay credenciales ---
        if (digitalON) {
          if (!firmaCreds?.cer || !firmaCreds?.key || !firmaCreds?.password) {
            alert("Faltan .cer / .key / password para firmar. Enciende el switch y completa el modal.");
            setFirmaOpen(true);
            return;
          }

          // 1) Generar el PDF del preview como Blob
          const pdfBlob = await getPdfBlobFromPreview();

          // 2) Llamada multipart al endpoint unificado (crear + estampar + firmar)
          // aqui entra el candado de views para CURP y demas....
          let data = null; // <<<< se define aquí

          try {

            // 2) Llamada multipart al endpoint unificado (crear + estampar + firmar)
            data = await crearRecetaCrearYFirmarFirmada({
              camposReceta: nuevaReceta,
              pdf: new File([pdfBlob], "preview.pdf", { type: "application/pdf" }),
              cer: firmaCreds.cer,
              key: firmaCreds.key,
              password: firmaCreds.password,
            });

          } catch (err) {
            // aquí se consume el error 400 del candado
            alert(err?.response?.data?.error ?? "Error al firmar la receta.");
            return; // <<<< clave: no baja al if(data)
          }


          if (data) {
            alert("✅ Receta creada y firmada.");
            navigate("/dashboard/recetas");
          } else {
            alert("❌ Hubo un error al firmar la receta.");
          }
          return; // termina aquí el flujo ON
        }
      
        try {
          const recetaGuardada = await crearReceta(nuevaReceta); // 👈 ya no se pasa historia por separado
          if (recetaGuardada) {
            alert("✅ Receta guardada correctamente.");
            navigate("/dashboard/recetas");
          } else {
            alert("❌ Hubo un error al guardar la receta.");
          }
        } catch (error) {
          console.error("Error guardando la receta:", error);
          alert("❌ Error al guardar la receta.");
        }
      };
       // Wrapper con candado anti-doble-click.
      // El guard corta el segundo click; el finally libera el flag pase
      // lo que pase (returns tempranos, errores o exito).
      const handleGuardar = async () => {
        if (guardandoReceta) return;
        setGuardandoReceta(true);
        try {
          await _handleGuardarInterno();
        } finally {
          setGuardandoReceta(false);
        }
      };

      const [medicamentos, setMedicamentos] = useState(
          Array.isArray(receta?.medicamentos) && receta.medicamentos.length
            ? receta.medicamentos
            : [{ nombre: "", indicaciones: "" }]
        );
      
      
    return (
      
      <div className={`formulario-receta ${!modoPreview ? "" : "sin-formulario"}`}>
         <div className="quick-access-titulo">
          ⚡ Importante:
          <p>
            Es necesario que completes tu perfil antes de generar una receta. 
            Por norma oficial, debes tener tus datos personales completos y actualizados.
            Da click en <strong>"Editar Perfil"</strong> → para modificar tu información personal.
          </p>
            
          "Exportar a PDF"  → Genera un archivo PDF con la receta actual.
            {modoPreview && `"Reciclar Receta" → Crea una nueva receta basada en la actual.`}
            "Conf. Receta" → Personaliza el diseño y los datos de la receta (Disponible solo en Desktop).
            
            
          </div>

      
      {/* Formulario de ingreso de datos */}
      
      <RecetaFormularioForm
        modoPreview={modoPreview}
        receta={receta}
        paciente={paciente}
        setPaciente={setPaciente}
        pacientes={pacientes}
        setPacienteId={setPacienteId}
        handleAgregarPaciente={handleAgregarPaciente}
        opcionesAsociacion={opcionesAsociacion}
        consultaId={consultaId}
        setConsultaId={setConsultaId}
        pacienteId={pacienteId}
        setConfig={setConfig}
        config={config}
        medicamentos={medicamentos}
        setMedicamentos={setMedicamentos}
        firmaHabilitada={firmaHabilitada}
        digitalON={digitalON}
        setDigitalON={setDigitalON}
        setFirmaOpen={setFirmaOpen}
        setFirmaCreds={setFirmaCreds}
        handleGuardar={handleGuardar}
        guardandoReceta={guardandoReceta}
      />
      
      {/* Contenedor para la vista previa de la receta */}
      <div className="preview-container" ref={recetaRef}>
          <PreviewReceta 
              config={config} 
              camposConfigurables={camposConfigurables} 
              setConfig={setConfig} 
              paciente_id={pacienteId} 
              nombrePaciente={paciente}
              diagnostico={config.diagnostico} 
              tratamiento={config.tratamiento}
              medicamentos={medicamentos}  
              fecha={config.fecha} 
              digitalON={digitalON}
              edad_en_emision={config.edad_en_emision}
              signos_vitales_snapshot={config.signos_vitales_snapshot}
              fecha_nacimiento_en_emision={config.fecha_nacimiento_en_emision}
          />
      </div>
  
      {/* Botones principales */}
       <div className="botones-acciones">
          <button type="button" onClick={handleExportPDF} disabled={exportandoPDF}>
            {exportandoPDF ? "Exportando…" : "Exportar a PDF"}
          </button>
          {modoPreview && (
              <button onClick={() => {
                  setModoPreview(false);
                  setConfig(prevConfig => ({
                      ...prevConfig,
                      fecha: new Date().toLocaleDateString("fr-CA") // 🔹 Cambia la fecha al día de hoy SOLO al reciclar
                  }));
              }}>
                  Reciclar Receta
              </button>
          )}
          <button onClick={() => navigate("/dashboard/recetas")}>Volver</button>
          <button data-id="conf-receta" onClick={() => navigate("/dashboard/configuracion/receta")}>Conf. Receta</button>
          <button onClick={() => navigate("/dashboard/configuracion/perfil")}>Editar Perfil</button>
      </div>
  
      <FirmaEfimeraModal
        open={firmaOpen}
        onClose={() => setFirmaOpen(false)}
        onConfirm={({ cer, key, password }) => {
          setFirmaCreds({ cer, key, password }); // queda en memoria (no se sube aún)
          setFirmaOpen(false);                   // cierra modal
        }}
      />

  
  </div>
  
    );
  };


  export default RecetaFormulario;
